import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { SuccessIcon } from 'foundations-assets';
import MessageContainer from './MessageContainer';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.importArticles.panel';
const Message = ({
  importedArticleCount,
  messageLangKey,
  progressLangKey,
  progress,
  totalArticleCount
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "200",
    children: /*#__PURE__*/_jsxs(MessageContainer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `${I18N_PREFIX}.${messageLangKey}`,
        options: {
          count: totalArticleCount,
          icon: /*#__PURE__*/_jsx(View, {
            as: "span",
            marginInlineStart: "200",
            children: /*#__PURE__*/_jsx(SuccessIcon, {
              color: "fill-positive-default"
            })
          }),
          imported: importedArticleCount
        }
      }), /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PREFIX}.${progressLangKey}`,
          options: {
            count: progress
          }
        })
      })]
    })
  });
};
Message.propTypes = {
  completed: PropTypes.bool,
  importedArticleCount: PropTypes.number.isRequired,
  messageLangKey: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  progressLangKey: PropTypes.string.isRequired,
  totalArticleCount: PropTypes.number.isRequired
};
export default Message;